import { html } from "uhtml";
import { bookInfo } from "../../view-models/bookInfo.js";
import { Customised } from "../custom-element.js";

export class CassisTitle extends Customised(HTMLElement) {
	static tagName = "cassis-title";
	signals() {
		const metadata = bookInfo();
		return {
			title: metadata.title,
		};
	}
	render({ title }) {
		return html`<span>${title}</span>`;
	}
}
CassisTitle.define();
